/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getStatistics343: state => {
    return state.statistics343
  },
  getStatistics(state) {
    return state.statistics
  },
  getStatisticsReport(state) {
    return state.statisticsReport
  },
  getStatisticsReportMiz(state) {
    return state.statisticsReportmiz
  },
}
